import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAllApis } from '@/api/api';
import { UpdateCasbin, getPolicyPathByAuthorityId } from '@/api/casbin';
export default {
  name: 'Apis',
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  data: function data() {
    return {
      apiTreeData: [],
      apiTreeIds: [],
      needConfirm: false,
      apiDefaultProps: {
        children: 'children',
        label: 'description'
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res2, apis, res;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return getAllApis();
          case 1:
            res2 = _context.sent;
            apis = res2.data.apis;
            _this.apiTreeData = _this.buildApiTree(apis);
            _context.next = 2;
            return getPolicyPathByAuthorityId({
              authorityId: _this.row.authorityId
            });
          case 2:
            res = _context.sent;
            _this.activeUserId = _this.row.authorityId;
            _this.apiTreeIds = [];
            res.data.paths && res.data.paths.map(function (item) {
              _this.apiTreeIds.push('p:' + item.path + 'm:' + item.method);
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    nodeChange: function nodeChange() {
      this.needConfirm = true;
    },
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.authApiEnter();
    },
    // 创建api树方法
    buildApiTree: function buildApiTree(apis) {
      var apiObj = {};
      apis && apis.map(function (item) {
        item.onlyId = 'p:' + item.path + 'm:' + item.method;
        if (Object.prototype.hasOwnProperty.call(apiObj, item.apiGroup)) {
          apiObj[item.apiGroup].push(item);
        } else {
          Object.assign(apiObj, _defineProperty({}, item.apiGroup, [item]));
        }
      });
      var apiTree = [];
      for (var key in apiObj) {
        var treeNode = {
          ID: key,
          description: key + '组',
          children: apiObj[key]
        };
        apiTree.push(treeNode);
      }
      return apiTree;
    },
    // 关联关系确定
    authApiEnter: function authApiEnter() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var checkArr, casbinInfos, res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              checkArr = _this2.$refs.apiTree.getCheckedNodes(true);
              casbinInfos = [];
              checkArr && checkArr.map(function (item) {
                var casbinInfo = {
                  path: item.path,
                  method: item.method
                };
                casbinInfos.push(casbinInfo);
              });
              _context2.next = 1;
              return UpdateCasbin({
                authorityId: _this2.activeUserId,
                casbinInfos: casbinInfos
              });
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  type: 'success',
                  message: 'api设置成功'
                });
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};